export default "__VITE_ASSET__d5eb247d__"